export default class EmailCommand
{
    public from: string = ""
    public to: string[] = []
    public cc: string[] = []
    public bcc: string[] = []
    public subject: string = ""
    public message: string = ""
    public accessToken: string = ""
}